import myNetworkList from './myNetworkList';
import platformNetworkList from './platformNetworkList';
import networkWaitingJoinList from './networkWaitingJoinList';
import inviteOneNetworkCompany from './inviteOneNetworkCompany';
import inviteBatchNetworkCompany from './inviteBatchNetworkCompany';
import checkTicketVisible from './checkTicketVisible';
import registryNetworkCompany from './registryNetworkCompany';
import acceptNetworkRelation from './acceptNetworkRelation';
import cancelNetworkRelation from './cancelNetworkRelation';
import networkCompanyDetail from './networkCompanyDetail';
import sendNetworkRequest from './sendNetworkRequest';
import fuzzyQueryCity from './fuzzyQueryCity';
import updateRemark from './updateRemark';
import userUpdateCompanyRemark from './userUpdateCompanyRemark';
import userNetworkMyList from './userNetworkMyList';
import userNetworkCompanyDetail from './userNetworkCompanyDetail';
import cancelNetworkInvite from './cancelNetworkInvite';
import registryInfoCheck from './registryInfoCheck';
import imInviteChat from './imInviteChat';
import companyApplyTag from './companyApplyTag';

export default {
    /** 网络管理，我的网络列表 */
    myNetworkList,
    /** 网络管理，我的网络，公司详情 */
    networkCompanyDetail,
    /** 网络管理，平台网络列表 */
    platformNetworkList,
    /** 网络管理，待加入列表 */
    networkWaitingJoinList,
    /** 邀请公司，单个 */
    inviteOneNetworkCompany,
    /** 批量邀请公司 */
    inviteBatchNetworkCompany,
    /** 检查ticket是否可用 */
    checkTicketVisible,
    /** 注册公司，提交表单 */
    registryNetworkCompany,
    /** 网络管理，我的网络，接受链接 */
    acceptNetworkRelation,
    /** 网络管理，我的网络，取消链接 */
    cancelNetworkRelation,
    /** 网络管理，发送连接请求 */
    sendNetworkRequest,
    /** 模糊查询城市 */
    fuzzyQueryCity,
    /** 管理员更改备注 */
    updateRemark,
    /** 用户，更改备注 */
    userUpdateCompanyRemark,
    /** 用户，我的网络列表 */
    userNetworkMyList,
    /** 用户，公司详情 */
    userNetworkCompanyDetail,
    /** 取消网络邮件的邀请 */
    cancelNetworkInvite,
    /** 注册公司, 信息验证 */
    registryInfoCheck,
    /** 邀请会话 */
    imInviteChat,
    /** 为公司打标签 */
    companyApplyTag,

};



// WEBPACK FOOTER //
// ./src/api/network/index.ts